"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./AnalyticsTable.scss");

var _color = _interopRequireDefault(require("color"));

var _lodash = _interopRequireDefault(require("lodash"));

var _AnalyticsTableHead = _interopRequireDefault(require("./AnalyticsTableHead"));

var _AnalyticsTableBody = _interopRequireDefault(require("./AnalyticsTableBody"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class AnalyticsTable extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      report: undefined,
      sortBy: undefined,
      sortOrder: undefined
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.report !== this.props.report) {
        this.getReport();
      }
    });

    _defineProperty(this, "getReport", () => {
      const _this$props = this.props,
            report = _this$props.report,
            sortBy = _this$props.sortBy,
            sortOrder = _this$props.sortOrder,
            urlPattern = _this$props.urlPattern;
      this.setState({
        totals: [],
        maximums: [],
        minimums: [],
        sortedRows: [],
        rows: []
      });

      if (!report) {
        return false;
      }

      const dimensionHeaders = report.columnHeader.dimensions;
      const metricHeaders = report.columnHeader.metricHeader.metricHeaderEntries;
      const _report$data = report.data,
            totals = _report$data.totals,
            maximums = _report$data.maximums,
            minimums = _report$data.minimums,
            rows = _report$data.rows;
      const orderBys = report.request.orderBys;
      let defaultSortBy, defaultSortOrder;

      if (orderBys && orderBys[0]) {
        defaultSortBy = orderBys[0].fieldName;
        defaultSortOrder = orderBys[0].sortOrder;
      }

      const sortedRows = rows.map(row => {
        let metric = {};
        dimensionHeaders.map((d, index) => {
          metric[d] = row.dimensions[index];
        });
        metricHeaders.map((m, index) => {
          const name = m.name;
          metric[name] = parseFloat(row.metrics[0].values[index]);
        });
        return _extends({}, row, {}, metric);
      });
      this.setState({
        urlPattern: urlPattern,
        dimensionHeaders: dimensionHeaders,
        metricHeaders: metricHeaders,
        totals: totals[0].values,
        maximums: maximums[0].values,
        minimums: minimums[0].values,
        sortedRows: sortedRows,
        rows: rows,
        sortBy: sortBy || defaultSortBy || metricHeaders[0].name,
        sortOrder: sortOrder || defaultSortOrder
      });
    });

    _defineProperty(this, "getClassName", () => {
      return "admin-analytics-table";
    });

    _defineProperty(this, "onSort", (sortBy, sortOrder) => {
      if (this.props.onSort) {
        this.props.onSort(sortBy, sortOrder);
      }

      let sortedRows = this.state.sortedRows;
      sortedRows = _lodash.default.orderBy(sortedRows, sortBy, sortOrder); // Use Lodash to sort array by 'name'

      console.log('sortedRows', sortedRows);
      this.setState({
        sortBy: sortBy,
        sortOrder: sortOrder,
        sortedRows: sortedRows
      });
    });

    _defineProperty(this, "getThemeStyle", () => {
      const theme = this.props.theme;

      if (!theme) {
        return {};
      }

      const primaryColor = theme.primaryColor;

      if (!primaryColor) {
        return {};
      }

      const backgroundColor = (0, _color.default)(primaryColor);
      let color;

      if (backgroundColor.isDark()) {
        color = "white";
      } else {
        color = "black";
      }

      return {
        backgroundColor: backgroundColor,
        color: color
      };
    });
  }

  componentDidMount() {
    this.getReport();
  }

  render() {
    const className = this.getClassName();
    const _this$state = this.state,
          metricHeaders = _this$state.metricHeaders,
          metricRows = _this$state.metricRows,
          sortBy = _this$state.sortBy,
          sortOrder = _this$state.sortOrder;

    if (!metricHeaders) {
      return false;
    }

    const thWidth = 30;
    const thStyle = {
      width: thWidth + "%"
    };
    const tdWidth = (100 - thWidth) / metricHeaders.length;
    const tdStyle = {
      width: tdWidth + "%"
    };
    const themeStyle = this.getThemeStyle();
    return _react.default.createElement("table", {
      className: className
    }, _react.default.createElement(_AnalyticsTableHead.default, _extends({}, this.state, {
      thStyle: thStyle,
      tdStyle: tdStyle,
      themeStyle: themeStyle,
      onSort: this.onSort
    })), _react.default.createElement(_AnalyticsTableBody.default, _extends({}, this.state, {
      thStyle: thStyle,
      tdStyle: tdStyle,
      onSort: this.onSort
    })));
  }

}

_defineProperty(AnalyticsTable, "defaultProps", {
  urlPattern: undefined,
  report: undefined,
  sortBy: undefined,
  sortOrder: 'ascending'
});

var _default = AnalyticsTable;
exports.default = _default;
module.exports = exports.default;